import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "includes"
})
export class IncludesPipe implements PipeTransform {

    transform(texto: string, posibleOpciones: string[]): boolean {
        return posibleOpciones.some(x => texto.includes(x));
    }

}
